import { useCallback } from 'react';
import { useGenericEntities } from 'app/agriculture/queries/entities/useGenericEntities';

/**
 * Returns a method to get the entity type for a given id
 */
export function useGetEntityType() {
    const genericEntities = useGenericEntities();

    return useCallback(
        (id: string | number) => {
            const entity = genericEntities.get(id);

            if (!entity) throw new Error(`Unable to find entity type for: ${id.toString()}`);

            return entity.type;
        },
        [genericEntities],
    );
}
